import * as React from 'react'
import { TeamActionListConnected } from './TeamActionListConnected'
import { Provider } from 'react-redux'
import { mockState, createMockStore, MOCK_TEAM_A_ID } from 'mockState'

export const TeamActionListExamples = () => {
  return (
    <div className="TeamActionListExamples exampleContainer">
      <h1 className="exampleHeader">default</h1>

      <Provider store={createMockStore(mockState)}>
        <TeamActionListConnected teamId={MOCK_TEAM_A_ID} />
      </Provider>
    </div>
  )
}
